import {combineReducers} from "@reduxjs/toolkit";

// --- Org / Manager / IOT reducers ---
import authReducer from "../slices/authSlice"
import profileReducer from "../slices/profileSlice"
import paymentReducer from "../slices/payment"
import managerReducer from "../slices/manager"
import devicesReducer from "../slices/devices"
import usersReducer from "../slices/users"
import attendanceReducer from "../slices/Attendance"
import holidaysReducer from "../slices/holidayslist"
import leavesReducer from "../slices/leaves"
import notificationReducer from "../slices/notification"

// --- Employee self-service reducers ---
// 'user' renamed -> 'employeeAuth' so it doesn't collide with usersReducer above,
// which already owns the 'user' key (org's enrolled-employee list).
import employeeAuthReducer from "../slices/employee/userAuthSlice"
import userLeaveReducer from "../slices/employee/userLeave"
import userAttendanceReducer from "../slices/employee/userAttendance"
import userHolidaysReducer from "../slices/employee/userHolidays"

const rootReducer = combineReducers({
    auth: authReducer,
    profile: profileReducer,
    payment: paymentReducer,
    manager: managerReducer,
    device: devicesReducer,
    user: usersReducer,
    Attendance: attendanceReducer,
    Holidays: holidaysReducer,
    Leave: leavesReducer,
    Notification: notificationReducer,

    employeeAuth: employeeAuthReducer,
    userLeave: userLeaveReducer,
    userAttendance: userAttendanceReducer,
    userHolidays: userHolidaysReducer,
})

export default rootReducer